import React from 'react';
import { useDispatch } from 'react-redux';

import { dashboardClienteAction } from "components/ApplicationInsights/eventNames";
import XmlNfeSlider from 'components/XmlNfeSlider';
import { MenuItem } from "..";

import xmlNfe from 'img/icon-nfe.svg';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './styles.scss';

import { IMenuItem } from '../interface';

interface IProps {
  itemComponent: React.FC<IMenuItem>,
  clickAction?: Function;
}

const XmlInvoice: React.FC<IProps> = (props: IProps) => {
  const { itemComponent, clickAction } = props;

  const dispatch = useDispatch();

  const defaultClickAction = () => {
    dispatch({
      type: 'OPEN_SLIDER',
      data: {
        title: 'XML NFe',
        subtitle:
          'Utilize os campos abaixo para localizar o seu pedido.',
        show: true,
        content: XmlNfeSlider,
      },
    });
  };

  return React.createElement(itemComponent, {
    title: "XML",
    subtitle: "NFe",
    icon: xmlNfe,
    trackName: dashboardClienteAction.DASHCLIENTE_XMLNFE,
    onClick: () => clickAction ? clickAction() : defaultClickAction(),
    id: "xml-invoice-menu-item"
  });
};

export default XmlInvoice;